<h2 mat-dialog-title>{{ data.label }}</h2>

<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ data.label }}</mat-label>

      <input
        #locationInput
        matInput
        formControlName="value"
        [matAutocomplete]="locationAuto"
        (input)="filterLocation()"
        placeholder="Enter location"
      />

      <span matSuffix class="autocomplete-spinner">
        @if (loading()) {
          <mat-spinner diameter="20"></mat-spinner>
        }
      </span>

      <mat-autocomplete
        #locationAuto="matAutocomplete"
        [displayWith]="displayLocation.bind(this)"
        (optionSelected)="onLocationSelected($event)"
      >
        @for (option of filteredOptions; track option.id) {
          <mat-option [value]="option">
            {{ formatLocation(option) }}
          </mat-option>
        }
      </mat-autocomplete>

      @if (form.get('value')?.hasError('invalidLocation')) {
        <mat-error>Please select a location from the list</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Radius</mat-label>
      <input matInput type="number" formControlName="radius" step="25" />
      <span matTextSuffix>mi</span>

      @if (form.get('radius')?.hasError('max')) {
        <mat-error>
          Maximum radius is {{ maxSearchRadius }} miles
        </mat-error>
      }

      @if (form.get('radius')?.hasError('min')) {
        <mat-error>
          Minimum radius is {{ minSearchRadius }} miles
        </mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="clear()">Clear</button>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-flat-button type="submit">Save</button>
  </mat-dialog-actions>
</form>